import page from 'page';
import * as ko from 'knockout';
ko.bindingHandlers["router"] = {
    init: function (element, valueAccessor, allBindingsAccessor) {
        //window.router
        var link = element;
        var value = ko.utils.unwrapObservable(valueAccessor());
        if (!value)
            return;
        var stopRouter = allBindingsAccessor().routerWhen === false;
        if (stopRouter)
            return;
        var evt = function (e) {
            e.preventDefault();
            e.stopPropagation();
            var v2 = ko.utils.unwrapObservable(valueAccessor());
            page(v2);
        };
        link.addEventListener('click', evt);
        //ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
        // This will be called when the element is removed by Knockout or
        // if some other part of your code calls ko.removeNode(element)
        //console.log(element);
        //});
    }
};
